var _g, _circle, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcoSiteMarker(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 26,
    viewBox: "0 0 24 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_339_1328)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.4063 17.7409C20.4063 17.7409 20.4144 17.7312 20.4176 17.7264C20.4192 17.7232 20.4225 17.72 20.4225 17.72C21.7278 15.9756 22.5 13.8126 22.5 11.4691C22.5 5.68693 17.7989 1 12.0008 1C6.20275 1 1.5 5.68693 1.5 11.4691C1.5 13.8126 2.27221 15.9756 3.57754 17.72C3.57754 17.72 3.58078 17.7248 3.58239 17.7264C3.58562 17.7312 3.59047 17.7361 3.5937 17.7409C3.61632 17.7715 3.66801 17.8359 3.74556 17.9342C3.86187 18.0807 3.97981 18.2241 4.1042 18.3642C5.16882 19.606 7.84087 22.4407 12.0008 25C16.1607 22.4407 18.8328 19.606 19.8974 18.3642C20.0202 18.2241 20.1397 18.0807 20.2561 17.9342C20.3336 17.8375 20.3853 17.7715 20.4079 17.7409H20.4063Z",
    fill: "#70C9BD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.8324 17.2566C19.8271 17.2633 19.8209 17.2713 19.8141 17.2807C19.8034 17.2944 19.7933 17.3084 19.7837 17.3227C19.7617 17.3511 19.7247 17.3979 19.6711 17.4648L19.6686 17.4679C19.5598 17.605 19.448 17.739 19.3333 17.8699L19.3333 17.8699L19.328 17.8761C18.3307 19.0394 15.8509 21.6754 12.0008 24.1158C8.15069 21.6754 5.67096 19.0394 4.67359 17.876L4.67368 17.876L4.66508 17.8663C4.55284 17.7399 4.44414 17.6079 4.33303 17.4679L4.23757 17.3473L4.20808 17.3097L4.19953 17.2987C4.19918 17.2982 4.19887 17.2978 4.19859 17.2974C4.19727 17.2956 4.19599 17.2939 4.19477 17.2922C4.18839 17.2836 4.18275 17.2764 4.17838 17.2709L4.17658 17.2687C2.96578 15.6498 2.25 13.6441 2.25 11.4691C2.25 6.10336 6.61474 1.75 12.0008 1.75C17.3867 1.75 21.75 6.10321 21.75 11.4691C21.75 13.6387 21.0378 15.6399 19.8324 17.2566ZM4.16351 17.2527C4.16316 17.2522 4.16318 17.2523 4.16344 17.2526C4.16349 17.2526 4.16354 17.2527 4.1636 17.2528L4.16351 17.2527Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.8,
    cx: 12,
    cy: 11,
    r: 3,
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_339_1328",
    x: 0.5,
    y: 0,
    width: 23,
    height: 26,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_339_1328"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_339_1328",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoSiteMarker);
export default __webpack_public_path__ + "static/media/ico-site-marker.c4ee3443a061034f8ae49b93ffd66603.svg";
export { ForwardRef as ReactComponent };